// Mock data for Shri Enterprise

export const heroData = {
  tagline: "Engineering Transparent Perfection.",
  subtext: "Shri Enterprise – Specialists in Architectural Aluminium Systems & Structural Glazing Solutions.",
  heroImages: [
    "https://images.unsplash.com/photo-1654105727849-1b9d39357f16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBnbGFzcyUyMGZhY2FkZXxlbnwwfHx8fDE3NjUyNzg4OTB8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1641787354718-46774dd8f94a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxjdXJ0YWluJTIwd2FsbHxlbnwwfHx8fDE3NjUyNzg5MDJ8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1720421112998-d2239ba1c2c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxjdXJ0YWluJTIwd2FsbHxlbnwwfHx8fDE3NjUyNzg5MDJ8MA&ixlib=rb-4.1.0&q=85"
  ]
};

export const aboutData = {
  title: "20+ Years Combined Experience in High-Precision Architectural Installations.",
  description: "At Shri Enterprise, we specialize in delivering world-class architectural aluminium and structural glazing solutions. Our team combines technical expertise with artistic precision to create stunning facades that define modern architecture.",
  expertise: [
    "ISO Certified Installation Processes",
    "IGBC Green Building Compliant",
    "Advanced Safety Standards",
    "Technical Mastery in Complex Installations",
    "Precision Engineering Excellence"
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Architectural Aluminium Windows & Door Systems",
    description: "Premium aluminium window and door solutions with superior thermal performance, acoustic insulation, and weather resistance.",
    icon: "Square",
    image: "https://images.unsplash.com/photo-1626894005353-b82d5f0f5e10?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3R1cmFsJTIwYWx1bWluaXVtJTIwd2luZG93fGVufDB8fHx8MTc2NTI3ODkyOHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    title: "Structural Glazing & Curtain Wall Systems",
    description: "State-of-the-art curtain wall systems offering seamless glass facades with maximum transparency and structural integrity.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1699287758475-d11df8dab2d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxnbGFzcyUyMGZhY2FkZXxlbnwwfHx8fDE3NjUyNzg5MzR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    title: "ACP (Composite Panel) Design & Installation",
    description: "High-quality aluminium composite panel cladding for modern facades with fire-rated materials and weather-resistant finishes.",
    icon: "Layers",
    image: "https://images.unsplash.com/photo-1652366643487-a432187cbff8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxhcmNoaXRlY3R1cmFsJTIwYWx1bWluaXVtJTIwd2luZG93fGVufDB8fHx8MTc2NTI3ODkyOHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    title: "Industrial Glass Work & Façade Engineering",
    description: "Comprehensive glass facade solutions for commercial and industrial projects with advanced engineering capabilities.",
    icon: "Boxes",
    image: "https://images.unsplash.com/photo-1654105727849-1b9d39357f16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxnbGFzcyUyMGZhY2FkZXxlbnwwfHx8fDE3NjUyNzg5MzR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    title: "Skylights, Canopies & Frameless Glass Solutions",
    description: "Custom-designed skylight systems and frameless glass installations bringing natural light into architectural spaces.",
    icon: "Sun",
    image: "https://images.unsplash.com/photo-1692624654117-9df7f0d9a4c1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwzfHxnbGFzcyUyMGZhY2FkZXxlbnwwfHx8fDE3NjUyNzg5MzR8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 6,
    title: "Custom Architectural Integration",
    description: "Bespoke aluminium and glazing solutions tailored to your unique architectural requirements and design vision.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1651420952022-2d2e666e87df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxhcmNoaXRlY3R1cmFsJTIwYWx1bWluaXVtJTIwd2luZG93fGVufDB8fHx8MTc2NTI3ODkyOHww&ixlib=rb-4.1.0&q=85"
  }
];

export const whyChooseUsData = [
  {
    title: "Precision Engineering",
    description: "Millimeter-perfect installations using advanced measurement and calculation systems.",
    icon: "Ruler"
  },
  {
    title: "Weatherproof & Acoustic Performance",
    description: "Superior sealing technology ensuring maximum weather resistance and sound insulation.",
    icon: "Cloud"
  },
  {
    title: "Energy Efficiency & Sustainability",
    description: "Eco-friendly solutions with optimal thermal performance reducing energy consumption.",
    icon: "Leaf"
  },
  {
    title: "High Structural Strength & Safety",
    description: "Engineered for maximum load-bearing capacity with comprehensive safety protocols.",
    icon: "Shield"
  },
  {
    title: "Customized Architectural Integration",
    description: "Seamless integration with your architectural vision and design requirements.",
    icon: "Puzzle"
  }
];

export const projectsData = [
  {
    id: 1,
    category: "Commercial",
    title: "Modern Corporate Tower",
    image: "https://images.unsplash.com/photo-1634412114581-6376e49ef8e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBnbGFzc3xlbnwwfHx8fDE3NjUyNzg5NjZ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    category: "Residential",
    title: "Luxury Glass Villa",
    image: "https://images.unsplash.com/photo-1641459380451-33804f2cf355?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBnbGFzc3xlbnwwfHx8fDE3NjUyNzg5NjZ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    category: "Industrial",
    title: "Manufacturing Facility",
    image: "https://images.unsplash.com/photo-1681857257117-6cde3e8c561a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBnbGFzc3xlbnwwfHx8fDE3NjUyNzg5NjZ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    category: "Commercial",
    title: "Business Park Complex",
    image: "https://images.unsplash.com/photo-1712678868500-5563a39efd07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBnbGFzc3xlbnwwfHx8fDE3NjUyNzg5NjZ8MA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 5,
    category: "Modern Façades",
    title: "Contemporary Office Building",
    image: "https://images.pexels.com/photos/35113884/pexels-photo-35113884.jpeg"
  },
  {
    id: 6,
    category: "Residential",
    title: "Premium Apartment Complex",
    image: "https://images.pexels.com/photos/35116070/pexels-photo-35116070.jpeg"
  },
  {
    id: 7,
    category: "Commercial",
    title: "Retail Shopping Center",
    image: "https://images.unsplash.com/photo-1631718596154-a19f88c0c00c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHw0fHxjb21tZXJjaWFsJTIwZmFjYWRlfGVufDB8fHx8MTc2NTI3ODk3Mnww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 8,
    category: "Modern Façades",
    title: "Mixed-Use Development",
    image: "https://images.pexels.com/photos/35115138/pexels-photo-35115138.jpeg"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Ar. Rajesh Mehta",
    role: "Principal Architect, Skyline Designs",
    text: "Shri Enterprise's precision in executing our curtain wall design was exceptional. Their technical expertise transformed our vision into reality."
  },
  {
    id: 2,
    name: "Vikram Patel",
    role: "Project Manager, Prestige Constructions",
    text: "Outstanding quality and timely execution. Their aluminium window systems exceeded our expectations in both aesthetics and performance."
  },
  {
    id: 3,
    name: "Priya Sharma",
    role: "Interior Designer, Elite Interiors",
    text: "The attention to detail and seamless integration with our design requirements made Shri Enterprise our go-to partner for all glazing projects."
  }
];

export const technicalSpecsData = [
  {
    id: 1,
    title: "Aluminium Profile Systems",
    description: "Technical specifications for window and door profiles",
    icon: "FileText"
  },
  {
    id: 2,
    title: "Glazing Systems Documentation",
    description: "Structural glazing and curtain wall specifications",
    icon: "FileText"
  },
  {
    id: 3,
    title: "ACP Specifications",
    description: "Composite panel technical data and fire ratings",
    icon: "FileText"
  },
  {
    id: 4,
    title: "Installation Process Guide",
    description: "Step-by-step installation methodology and safety protocols",
    icon: "FileText"
  }
];

export const contactData = {
  phone: ["+91 9106078378", "+91 9825519039"],
  email: "shrienterprise98@gmail.com",
  address: "5, Labdhi Ind Estate, Acid Mill Compound, Ranmukteshwar Road, Pratapnagar, Vadodara, Gujarat",
  coverage: "All over India"
};
